// Modelled after the pattern used in the backend
// See libraries/syringe.pyL24 'VARIABLE_REFERENCE_REGEX' in api
// The regex specifically checks that the variable id (left side of |) is a 24 character string
// This is because sometimes the pattern {|} can occur in user-inputted text (in particular, jinja templates)
// and we don't want to match that
export const VARIABLE_REFERENCE_REGEX = /\{(\w{24})\|((?:[^{}]|\{[^{}]*})*)}/gi;
export const INFERRED_VARIABLE_REFERENCE_REGEX = /\{\{([^}]+)}}/gi;
